import React, { useEffect, useState } from 'react';
import { Grid, Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useNavigate, useParams } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { styles } from './styles';
import DepartmentData from '../../../features/departments/DepartmentData';
import { useViewDepartmentMutation } from '../../../api/departments';

const ViewDepartment = (props) => {
    const navigate = useNavigate();
    const params = useParams();
    const [departmentDetails, setDepartmentDetails] = useState({});

    const { enqueueSnackbar } = useSnackbar();
    const [viewDepartment, { isLoading }] = useViewDepartmentMutation();

    useEffect(() => {
        async function fetchData() {
            const bodyFormData = new FormData();
            bodyFormData.append('id', params.id);
            try {
                const response = await viewDepartment(bodyFormData).unwrap();
                if (!response) return;
                if (response?.status === 'ERROR') throw new Error(response?.message);
                setDepartmentDetails(response.results);
            } catch (err) {
                if (err?.statusCode === 400) enqueueSnackbar(err?.data?.message, { variant: 'error' });
                else enqueueSnackbar(err?.message || 'Something went wrong!', { variant: 'error' });
            }
        }
        fetchData();
    }, [params.id, viewDepartment, enqueueSnackbar]);

    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">Departments</Typography>
            </Box>
            <Box sx={styles.contentBodyWrapper}>
                <Card {...props}>
                    <CardContent>
                        <Grid container direction="column" spacing={2}>
                            <Grid item>
                                <Button
                                    startIcon={<ChevronLeftIcon />}
                                    variant="text"
                                    color="secondary"
                                    onClick={() => navigate('/settings/departments')}
                                >
                                    Back
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <DepartmentData department={departmentDetails} id={params.id} isLoading={isLoading} />
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default ViewDepartment;
